<img src="/assets/images/login/dialog/close.svg" alt="Cerrar" class="close-icon" (click)="close()">
<div class="title" [innerHTML]="'contact_Data11' | i18n"></div>
<div class="description" [innerHTML]="'contact_Data12' | i18n"></div>
<button (click)="close()" [innerHTML]="'contact_Data13' | i18n"></button>
